import { get, post, put, deleted as del } from '../../../services';

const ReportService = {
  // Execute dynamic search
  executeSearch: async (entity, criteria) => {
    try {
      const response = await post(`search/${entity}/execute`, criteria);
      return response;
    } catch (error) {
      console.error('Error executing search:', error);
      throw error;
    }
  },

  // Save a search configuration
  saveSearch: async (entityType, name, criteria, isPublic = false, isReport = false) => {
    try {
      const response = await post(`search/${entityType}/save`, {
        name,
        criteria: criteria, // Send criteria directly, not wrapped
        isPublic,
        isReport
      });
      return response;
    } catch (error) {
      console.error('Error saving search:', error);
      throw error;
    }
  },

  // Get saved searches
  getSavedSearches: async (entityType, includePublic = true, reportsOnly = false) => {
    try {
      const params = new URLSearchParams({
        includePublic: includePublic.toString(),
        reportsOnly: reportsOnly.toString()
      });
      const response = await get(`search/${entityType}/saved?${params}`);
      return response;
    } catch (error) {
      console.error('Error getting saved searches:', error);
      throw error;
    }
  },

  // Get a specific saved search
  getSavedSearch: async (entityType, searchId) => {
    try {
      const response = await get(`search/${entityType}/saved/${searchId}`);
      return response;
    } catch (error) {
      console.error('Error getting saved search:', error);
      throw error;
    }
  },

  // Execute a saved search
  executeSavedSearch: async (entityType, searchId, limit = 1000, offset = 0) => {
    try {
      // const params = new URLSearchParams({
      //   limit: limit.toString(),
      //   offset: offset.toString()
      // });
      const response = await get(`search/${entityType}/execute/${searchId}`);
      return response;
    } catch (error) {
      console.error('Error executing saved search:', error);
      throw error;
    }
  },

  // Update a saved search
  updateSavedSearch: async (entityType, searchId, updates) => {
    try {
      const response = await put(`search/${entityType}/saved/${searchId}`, updates);
      return response;
    } catch (error) {
      console.error('Error updating saved search:', error);
      throw error;
    }
  },

  // Delete a saved search
  deleteSavedSearch: async (entityType, searchId) => {
    try {
      const response = await del(`search/${entityType}/saved/${searchId}`);
      return response;
    } catch (error) {
      console.error('Error deleting saved search:', error);
      throw error;
    }
  },

  // Get entity metadata
  getEntityMetadata: async (entity) => {
    try {
      const response = await get(`search/${entity}/metadata`);
      return response;
    } catch (error) {
      console.error('Error getting entity metadata:', error);
      throw error;
    }
  },

  // Get all reports
  getReports: async () => {
    try {
      const response = await get('search/list-reports');
      return response;
    } catch (error) {
      console.error('Error getting reports:', error);
      throw error;
    }
  },

  // Export report data
  exportReport: async (entity, criteria, format = 'csv') => {
    try {
      const response = await post(`search/${entity}/export`, {
        criteria,
        format,
        limit: 50000 // Higher limit for exports
      }, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      console.error('Error exporting report:', error);
      throw error;
    }
  }
};

export default ReportService;